import {DomainEvent} from './DomainEvent';
import {ProfileTransfer} from '../resources/ProfileTransfer';

export class ProfileTransferCreated extends DomainEvent<ProfileTransfer> {}
